import { fmt } from '../../i18n'
import { formatDuration } from '../../lib/format'
import type { HeatCell } from '../../lib/heatmap'
import { useLocale } from '../use-locale'

/** 最近の灯り: 日ごとの集中時間を、灯りの強さで並べる（日曜始まりの週が列） */
export function LampHeatmap({ grid }: { grid: HeatCell[][] }) {
  const { t, locale } = useLocale()
  const cells = grid.flatMap((col, w) => col.map((c, d) => ({ ...c, w, d })))
  return (
    <figure className="lamp-heatmap">
      <div
        className="lamp-heatmap__grid"
        role="img"
        aria-label={t.profile.heatmapTitle}
        style={{ gridTemplateColumns: `repeat(${grid.length}, minmax(0, 1fr))`, maxWidth: grid.length * 24 }}
      >
        {cells.map((c) => (
          <span
            key={c.date}
            className={`lamp-heatmap__cell lamp-heatmap__cell--${c.level}`}
            style={{ gridColumn: c.w + 1, gridRow: c.d + 1 }}
            title={fmt(t.profile.heatmapCell, { date: c.date, duration: formatDuration(c.seconds, locale) })}
          />
        ))}
      </div>
      <figcaption className="lamp-heatmap__legend">
        <span>{t.profile.heatmapLess}</span>
        {[0, 1, 2, 3, 4].map((l) => (
          <span key={l} className={`lamp-heatmap__cell lamp-heatmap__cell--${l}`} aria-hidden="true" />
        ))}
        <span>{t.profile.heatmapMore}</span>
      </figcaption>
    </figure>
  )
}
